
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"c-amex-sponsor\">\r\n    in partnership with\r\n    <div class=\"s-sponsor-amex-logo\"></div>\r\n</div>");